module.exports = __webpack_public_path__ + "static/media/colorfulman.2f71619d.png";